import * as _history from "history";

export default _history.createBrowserHistory();
